"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectLtPriceForM = exports.connectLtPrice = exports.getBRLPrice = exports.transferMixUnitPrice = exports.stringToPrice = exports.formatPriceWithPoint = void 0;
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var country_1 = require("./country");
exports.formatPriceWithPoint = function (price, bit) {
    if (bit === void 0) { bit = 2; }
    if (typeof price === "string") {
        price = parseFloat(price);
    }
    var base = Math.pow(10, bit);
    return (Math.round(price * base) / base).toFixed(bit);
};
exports.stringToPrice = function (priceString) {
    return parseFloat(priceString.replace(/[^\.\d]/g, ""));
};
function transferMixUnitPrice(integerPrice) {
    var price = integerPrice / 100;
    return Number(price.toFixed(2));
}
exports.transferMixUnitPrice = transferMixUnitPrice;
exports.getBRLPrice = function (currency, price) {
    if (currency) {
        return currency + " " + isomorphismConstant_1.default.priceGraph + (price ? price.replace(".", ",") : price);
    }
    else {
        return isomorphismConstant_1.default.priceGraph + (price ? price.replace(".", ",") : price);
    }
};
var noNationalSmbols = function (country) {
    return isomorphismConstant_1.default.currency === country;
};
var specialSymbol = function (price, isOrigin, symbol) {
    return isOrigin ? symbol + price : isomorphismConstant_1.default.priceGraph + price;
};
exports.connectLtPrice = function (price, isOrigin) {
    if (isOrigin === void 0) { isOrigin = false; }
    if (country_1.middleEastCountries.some(function (i) { return i === isomorphismConstant_1.default.currency; })) {
        return isomorphismConstant_1.default.currency + " " + price;
    }
    else if (isomorphismConstant_1.default.currency === "BRL") {
        return exports.getBRLPrice(isomorphismConstant_1.default.currency, price);
    }
    else if (noNationalSmbols("MXN")) {
        return specialSymbol(price, isOrigin, "$");
    }
    else if (noNationalSmbols("CHF")) {
        return specialSymbol(price, isOrigin, "₣");
    }
    else {
        return isomorphismConstant_1.default.currency + " " + isomorphismConstant_1.default.priceGraph + price;
    }
};
exports.connectLtPriceForM = function (price, isOrigin) {
    if (country_1.middleEastCountries.some(function (i) { return i === isomorphismConstant_1.default.currency; })) {
        return isomorphismConstant_1.default.currency + " " + price;
    }
    else if (isomorphismConstant_1.default.currency === "JOD" || isomorphismConstant_1.default.currency === "CAD") {
        return isomorphismConstant_1.default.currency + " " + isomorphismConstant_1.default.priceGraph + price;
    }
    else if (isomorphismConstant_1.default.currency === "BRL") {
        return exports.getBRLPrice(null, price);
    }
    else if (noNationalSmbols("MXN")) {
        return specialSymbol(price, isOrigin, "$");
    }
    else if (noNationalSmbols("CHF")) {
        return specialSymbol(price, isOrigin, "₣");
    }
    else {
        return isomorphismConstant_1.default.priceGraph + price;
    }
};
